import { APIGet, APIPut, APIUrl, AdminType } from "api/protocols";

interface IGetPricingSheets {
  id?: number;
  extended?: boolean;
  day_of_week_number?: number;
  application?: string;
}

export interface IPutCheckIns {
  id: number;
  customer_type_id: number;
  pricing_sheet_id: number;
  variant_id: number;
  holes: number;
  tee_sheet_price_override: number;
  online_price_override: number;
  prepaid_price_override_fixed: number;
  prepaid_price_override_percent: number;
}

interface IGetCheckIns {
  facility_id?: number;
  day_of_week_number?: number;
  application: Array<string>;
  customer_type_id?: number;
  customer_type_ids?: number[];
  holes?: number[];
  course_ids?: number[];
  limit?: number;
  no_variant?: number;
  search?: string;
}

interface IConfiguration {
  configurations: IPutCheckIns[];
}

interface IPutCopyCheckIns {
  check_in_ids: Array<number>;
  course_id?: number;
  day_of_week?: string;
  select_all_day_of_week?: string;
}

export async function GetCheckIns(params: IGetCheckIns, useGlobalLoader: boolean) {
  return APIGet(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/check-in"), params, useGlobalLoader);
}

export async function GetPricingSheets(params: IGetPricingSheets, useGlobalLoader: boolean) {
  return APIGet(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/pricing-sheet"), params, useGlobalLoader);
}

export async function PutCheckIns(params: IConfiguration, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/check-in"), params, useGlobalLoader);
}

export async function PutCopyCheckIns(params: IPutCopyCheckIns, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/check-in/copy"), params, useGlobalLoader);
}
